export default "__VITE_ASSET__D$ooI1sL__"